import { FEE_DECIMALS } from '@/features/markets/api/get-exchange-info';
import useFundedAccount from '@/hooks/use-funded-account';
import useSymbol from '@/hooks/use-symbol';
import { useMarketStore } from '@/store/use-markets-store';
import { TimeInForce } from '@/types';
import { formatBigInt } from '@/utils/value-format';
import { useFormContext } from 'react-hook-form';
import { useStore } from 'zustand';
import { getIsTaker } from '../../utils/helpers';
import { OrderFormSchema } from '../order-form';

export default function Fee() {
  const symbol = useSymbol();
  const takerFee = useStore(
    useMarketStore(symbol),
    (state) => state.marketSpec.takerFee,
  );
  const { isEval } = useFundedAccount();

  const form = useFormContext<OrderFormSchema>();
  const isTaker = getIsTaker(form.watch('order.timeInForce') as TimeInForce);

  if (isEval || !isTaker) return '0%';

  return formatBigInt(
    takerFee,
    FEE_DECIMALS - 2n, // to account for percent
    {
      style: 'percent',
    },
  );
}
